import moment from "moment";
import React, { useState, useEffect } from "react";
import { MdKeyboardArrowDown, MdKeyboardArrowUp } from "react-icons/md";

const OffersAndPackages = ({ data = [] }) => {
  const [expandedIndex, setExpandedIndex] = useState(null);
  const [offersData, setOffersData] = useState([]);
  const saveOffers = () => {
    setOffersData(data);
  };

  useEffect(() => {
    saveOffers();
  }, []);

  const toggleExpand = (index) => {
    setExpandedIndex(expandedIndex === index ? null : index);
  };
  // const today = new Date();

  const getCurrentDate = () => {
    const today = new Date();
    const year = today.getFullYear();
    const month = (today.getMonth() + 1).toString().padStart(2, "0");
    const day = today.getDate().toString().padStart(2, "0");
    return `${year}-${month}-${day}`;
  };

  const filteredOffers = data?.filter((offer) => {
    const currentDate = getCurrentDate();
    if (offer?.endDate) {
      const endDate = offer?.endDate;
      return endDate >= currentDate;
    }
    return true;
  });
  return (
    <div>
      {filteredOffers.length > 0 && (
        <h2 className="text-2xl font-bold mb-4">Offers & Packages</h2>
      )}

      {filteredOffers.map((offer, index) => (
        <div key={index} className="mb-4">
          <div
            className={`cursor-pointer bg-gray-100 p-4 ${
              expandedIndex === index ? "rounded-t-lg" : "rounded-lg"
            } flex justify-between items-center`}
            onClick={() => toggleExpand(index)}
          >
            <h3 className="text-xl font-semibold">
              {offer.title || "No Title"}
            </h3>
            <span>
              {expandedIndex === index ? (
                <MdKeyboardArrowUp className="text-3xl" />
              ) : (
                <MdKeyboardArrowDown className="text-3xl" />
              )}
            </span>
          </div>
          {expandedIndex === index && (
            <div
              className={`px-4 border-b ${
                expandedIndex === index ? "rounded-b-lg" : ""
              }  bg-gray-100`}
            >
              <div className="flex space-x-2 lg:w-1/2 w-full py-2 items-start justify-between">
                {offer.startDate && (
                  <div className="mb-2 flex flex-col">
                    <strong>From</strong>{" "}
                    {moment(offer.startDate).format("DD MMM, YYYY")}
                  </div>
                )}
                {offer.endDate && (
                  <div className="mb-2  flex flex-col">
                    <strong>To</strong>{" "}
                    {moment(offer.endDate).format("DD MMM, YYYY")}
                  </div>
                )}
              </div>
              {offer.description && (
                <>
                  <strong>Offer Description</strong>
                  <p className="mt-1 break-words">{offer.description}</p>
                </>
              )}
            </div>
          )}
        </div>
      ))}
    </div>
  );
};

export default OffersAndPackages;
